import React from 'react';
import PropTypes from 'prop-types';
import {Button, Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock} from 'react-bootstrap';

const ContactForm = (props) => {
  return (
    <Form horizontal>
      <FormGroup validationState={props.errors && props.errors.first_name ? 'error' : null } controlId="formFirstName">
        <Col xs={2} componentClass={ControlLabel}>
          First Name
        </Col>
        <Col xs={5}>
          <FormControl name="first_name" type="text" placeholder="First Name" value={props.preset.first_name} onChange={props.onChange}/>
          <FormControl.Feedback />
          { props.errors.first_name ? <HelpBlock>{props.errors.first_name}</HelpBlock> : '' }
        </Col>
      </FormGroup>
      <FormGroup validationState={props.errors && props.errors.last_name ? 'error' : null } controlId="formLastName">
        <Col xs={2} componentClass={ControlLabel}>
          Last Name
        </Col>
        <Col xs={5}>
          <FormControl name="last_name" type="text" placeholder="Last Name" value={props.preset.last_name} onChange={props.onChange}/>
          <FormControl.Feedback />
          { props.errors.last_name ? <HelpBlock>{props.errors.last_name}</HelpBlock> : '' }
        </Col>
      </FormGroup>
      <FormGroup validationState={props.errors && props.errors.email ? 'error' : null } controlId="formEmail">
        <Col xs={2} componentClass={ControlLabel}>
          Email
        </Col>
        <Col xs={5}>
          <FormControl name="email" type="text" placeholder="Email" value={props.preset.email} onChange={props.onChange}/>
          <FormControl.Feedback />
          { props.errors.email ? <HelpBlock>{props.errors.email}</HelpBlock> : '' }
        </Col>
      </FormGroup>
      <FormGroup validationState={props.errors && props.errors.phone ? 'error' : null } controlId="formPhone">
        <Col xs={2} componentClass={ControlLabel}>
          Phone
        </Col>
        <Col xs={5}>
          <FormControl name="phone" type="text" placeholder="Phone" value={props.preset.phone} onChange={props.onChange}/>
          <FormControl.Feedback />
          { props.errors.phone ? <HelpBlock>{props.errors.phone}</HelpBlock> : '' }
        </Col>
      </FormGroup>
      {
        props.fromContactPage &&
        <FormGroup>
          <Col xsOffset={3} xs={4}>
            <div className='text-right'>
              <Button className='secondary' onClick={props.onCancel}>Cancel</Button>
              <Button data-cy="save-contact-button" className='primary' type="submit" onClick={props.onSave} style={{ marginLeft: '15px' }}>Save</Button>
            </div>
          </Col>
        </FormGroup>
      }
    </Form>
  );
};

ContactForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  preset: PropTypes.object
};

export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/contacts/ContactForm.js